var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.96875C11.7188 0.96875 14.7812 4.03125 14.7812 7.75C14.7812 11.4961 11.7188 14.5312 8 14.5312C4.25391 14.5312 1.21875 11.4961 1.21875 7.75C1.21875 4.03125 4.25391 0.96875 8 0.96875ZM8 13.6562C11.2539 13.6562 13.9062 11.0039 13.9062 7.75C13.9062 4.49609 11.2266 1.84375 8 1.84375C4.71875 1.84375 2.09375 4.52344 2.09375 7.75C2.09375 11.0312 4.74609 13.6562 8 13.6562ZM11.8555 6.16406L6.93359 11.0586C6.79688 11.168 6.57812 11.168 6.46875 11.0586L4.11719 8.67969C3.98047 8.54297 3.98047 8.35156 4.11719 8.21484L4.33594 7.99609C4.47266 7.85938 4.69141 7.85938 4.80078 7.99609L6.6875 9.88281L11.1719 5.45312C11.2812 5.31641 11.5 5.31641 11.6367 5.45312L11.8555 5.69922C11.9922 5.80859 11.9922 6.02734 11.8555 6.16406Z"
  })));
};
export default __webpack_public_path__ + "assets/2d37dd6737b1181758287be7a89c1ac7.svg";
export { SvgSuccess as ReactComponent };


// WEBPACK FOOTER //
// ./components/messages/icons/success.svg